<div style="padding: 20px 0 20px 0;  display: flex; justify-content: center">
  <div style="display: flex; align-items: center; margin-right: 30px">
    <div style="width: 10px; height: 10px; background: #3a785d; margin-right: 10px"></div>
    <div>Available</div>
  </div>
  <div style="display: flex; gap: 10px; align-items: center; margin-right: 30px">
    <div style="width: 10px; height: 10px; background: #D4AF37; margin-right: 10px"></div>
    <div>Settled</div>
  </div>
  <div style="display: flex; gap: 10px; align-items: center; margin-right: 30px">
    <div style="width: 10px; height: 10px; background: #000000; margin-right: 10px"></div>
    <div>EOI | Reserved | Exchange conditional | Unconditional</div>
  </div>
  <div style="display: flex; gap: 10px; align-items: center; margin-right: 30px">
    <div style="width: 10px; height: 10px; background: #c3c3c3; margin-right: 10px"></div>
    <div>Unavailable</div>
  </div>
</div>
<div *ngIf="dataSourceForMatrix.length > 0"
  style=" padding: 20px 0 0 20px; display: flex; flex-direction: column; margin-top: 20px; background-color: rgba(195, 201, 209, 0.22); max-height: 600px; overflow-y: scroll; width: auto">
  <div style="margin-bottom: 5px">Level</div>
  <div *ngFor="let level of dataSourceForMatrix" style="display: flex; align-items: center; margin-bottom: 5px">
    <div style="min-width: 80px; margin-right: 5px">{{transformLevel(level.level)}}</div>
    <div style="display: flex; overflow-x: scroll">
      <div *ngFor="let property of level.properties; let i = index"
        style="position: relative; margin-right: 5px; cursor: pointer; font-size: 10px; display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 10px; width: 80px; height: 80px"
        (click)="editProperty(property)"
        [ngClass]="{'last': i === level.properties.length - 1, 'green': property.status === 1, 'red': property.status === 6, 'black': property.status === 5 ||  property.status === 4 ||  property.status === 3 ||  property.status === 2, 'grey': property.status === 0}">
        <p style="margin: 2px auto">{{property.unitNum}}</p>
        <p style="margin: 2px auto">{{property.bedRoom}} BRM</p>
        <p style="margin: 2px auto">{{property.bathRoom}} BTR</p>
        <p style="margin: 2px auto">{{property.carParking}} CAR</p>
        <p style="margin: 2px auto">{{property.price | currency: '':'symbol':'3.0'}}</p>
        <img src="./assets/images/edit.svg" style="position: absolute; top: 5px; right: 5px; width: 16px; height: 16px">
        <img src="./assets/images/floorplan.svg" *ngIf="property.floorPlan" style="position: absolute; top: 5px; left: 5px; width: 16px; height: 16px">
      </div>
    </div>
  </div>
</div>
<!--<div class="manage-property-container" fxLayout="row wrap" fxLayoutGap="10px">-->
<!--  <ng-container *ngIf="project && project.properties">-->
<!--    <div *ngFor="let property of project.properties">-->
<!--      <app-property-item [project]="project" [property]="property"></app-property-item>-->
<!--    </div>-->
<!--  </ng-container>-->
<!--</div>-->
<ng-container *ngIf="project && (!project.properties || project.properties.length === 0)">
  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0">
    <img src="./assets/images/empty.svg" style="width: 200px; height: 200px">
    <p style="color: #99bac4; margin-top: 0">No property found.</p>
  </div>
</ng-container>